/**
 * Modal Manager - handles modal functionality on Frontend.
 */

/**
 * Handles the functionality of opening and closing modals triggered by marker and cross buttons.
 *
 *
 * @returns {void} This function does not return a value.
 */
const handleMarkerModal = () => {
  const markerIcons = document.querySelectorAll('.js-marker-button')
  const crossButtons = document.querySelectorAll('.js-cross-button')

  if (markerIcons.length) {
    toggleModalOnMarkerClick(markerIcons)
  } else {
    return
  }

  if (crossButtons.length) {
    toggleModalOnCrossClick(crossButtons)
  } else {
    return
  }
}

/**
 * Attaches click event listeners to a collection of marker icons to toggle modals.
 * When a marker icon is clicked, all currently opened modals are closed, and the
 * modal associated with the clicked marker is toggled between open and closed states.
 *
 * @param {NodeList | HTMLElement[]} markerIcons - A collection of marker icon elements
 *                                                 that will trigger modal toggling on click.
 */
const toggleModalOnMarkerClick = ( markerIcons ) => {
  markerIcons.forEach(markerIcon => {
    markerIcon.addEventListener("click", (event) => {
      // Stop the click event from bubbling up to the image
      event.stopPropagation()

      // Get modal.
      const markerID = markerIcon.dataset.markerId
      const relatedModal = document.getElementById(markerID)

      if (!relatedModal) {
        return
      }

      // Stop the click event from bubbling up to the image, when clicking inside modal.
      relatedModal.addEventListener('click', (event) => {
        event.stopPropagation();
      });

      // Open selected modal.
      const modalState = relatedModal.dataset.state

      if ( modalState === 'closed' ) {
        // Close all opened modals first.
        CloseAllModals()

        handleModalMobile( relatedModal )
        OpenModal( relatedModal )
      } else if ( modalState === 'open' ) {
        CloseModal( relatedModal )
      }

    });
  })
}

/**
 * Attaches click event listeners to an array of cross buttons to toggle modals.
 * When a cross button is clicked, its parent element (assumed to be the modal)
 * is passed to the `CloseModal` function to close the modal.
 *
 * @param {NodeList | HTMLElement[]} crossButtons - A collection of cross button elements
 *                                                  that will trigger modal closing on click.
 */
const toggleModalOnCrossClick = ( crossButtons ) => {
  crossButtons.forEach(crossButton => {
    crossButton.addEventListener("click", () => {
      const modal = crossButton.parentElement

      CloseModal(modal)
    })
  })
}

/**
 * Opens a modal by updating its dataset state and toggling its "is-closed" class.
 *
 * @param {HTMLElement} modal - The modal element to be opened.
 */
const OpenModal = ( modal ) => {
  modal.dataset.state = 'open'
  modal.classList.toggle("is-closed");
}

/**
 * Closes a modal by updating its dataset state and toggling its "is-closed" class.
 *
 * @param {HTMLElement} modal - The modal element to be opened.
 */
const CloseModal = ( modal ) => {
  modal.dataset.state = 'closed'
  modal.classList.toggle("is-closed");
}

/**
 * Closes all modals on the page that are currently open.
 *
 */
const CloseAllModals = () => {
  const allModals = document.querySelectorAll('.js-modal')

  allModals.forEach(modal => {
    const modalState = modal.dataset.state

    if ( modalState === 'open' ) {
      CloseModal(modal)
    } else {
      return
    }
  })
}

const handleModalMobile = ( relatedModal ) => {
  const isMobile = window.screen.width <= 768 ? true : false

  if ( isMobile ) {
    relatedModal.style.left = `-10%`
  }
}

export default handleMarkerModal
